/**
 * Типы аккаунтов пользователей.
 */
export enum AccountType {
    /**
     * Инвестор. Тариф Базовый.
     */
    Base = 10,
    /**
     * Инвестор. Тариф Премиум.
     */
    Premium = 20,
    /**
     * Инвестор. Тариф Ультра.
     */
    Ultra = 30,

    /**
     * Инвестор. Тариф Акционер.
     */
    Sharer = 40,
}

/**
 * Соотнесение типа аккаунта с его названием.
 */
export const ACCOUNT_TYPE_MAP: Record<AccountType, string> = {
    [ AccountType.Base ]: 'Base',
    [ AccountType.Premium ]: 'Premium',
    [ AccountType.Ultra ]: 'Ultra',
    [ AccountType.Sharer ]: 'Sharer',
};

export interface IProps {
    type: AccountType;
    link?: string;
}

export function getBadgeClassName(type: AccountType) {
    switch (type) {
    case AccountType.Base:
        return 'badge--type-base';
    case AccountType.Premium:
        return 'badge--type-premium';
    case AccountType.Ultra:
        return 'badge--type-ultra';
    case AccountType.Sharer:
        return 'badge--type-sharer';
    default:
        return 'badge--type-regular';
    }
}